import { createTheme, ThemeOptions } from '@mui/material/styles';
import { green, purple, red } from '@mui/material/colors';

   
export const lightTheme = createTheme({
    palette: {
        type: 'light',
       
        background: {
            default: '#fff',
            paper: '#fff',
        },
    },
} as ThemeOptions)

export const darkTheme = createTheme({
    palette: {
        type: 'dark',
        primary: {
            main: "#1976d2",
          },
        background: {
            default: '#fff',
            paper: '#fff',
        },
    },
} as ThemeOptions)

type Type = 'light' | 'dark';

export const getTheme = (type: Type = "light"): ThemeOptions => {
    switch (type) {
        case 'light':
            return lightTheme;
        case 'dark':
            return darkTheme;
        default:
            return lightTheme;
    }
}